import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="otp-input"
export default class extends Controller {
  static targets = ["digit", "hiddenInput"]
  static values = { length: Number }

  connect() {
    this.lengthValue = this.lengthValue || 6
    this.digitTargets[0].focus()
  }

  handleInput(event) {
    const input = event.target
    const value = input.value
    const index = parseInt(input.dataset.index)

    // Only allow digits
    if (!/^\d$/.test(value)) {
      input.value = ''
      return
    }

    // Move to next input if available
    if (index < this.lengthValue - 1) {
      this.digitTargets[index + 1].focus()
    }

    this.updateHiddenInput()
  }

  handleKeydown(event) {
    const input = event.target
    const index = parseInt(input.dataset.index)

    // Handle backspace
    if (event.key === 'Backspace') {
      if (input.value === '' && index > 0) {
        // Move to previous input if current is empty
        this.digitTargets[index - 1].focus()
      } else {
        // Clear current input
        input.value = ''
      }
      this.updateHiddenInput()
      event.preventDefault()
    }

    // Handle arrow keys
    if (event.key === 'ArrowLeft' && index > 0) {
      this.digitTargets[index - 1].focus()
    }
    
    if (event.key === 'ArrowRight' && index < this.lengthValue - 1) {
      this.digitTargets[index + 1].focus()
    }
  }

  handlePaste(event) {
    event.preventDefault()
    const paste = event.clipboardData.getData('text')
    const digits = paste.replace(/\D/g, '').slice(0, this.lengthValue)

    digits.split('').forEach((digit, index) => {
      if (this.digitTargets[index]) {
        this.digitTargets[index].value = digit
      }
    })

    // Focus on the next empty input or the last one
    const nextEmptyIndex = Math.min(digits.length, this.lengthValue - 1)
    this.digitTargets[nextEmptyIndex].focus()

    this.updateHiddenInput()
  }

  updateHiddenInput() {
    const code = this.digitTargets.map(target => target.value).join('')
    this.hiddenInputTarget.value = code

    // Add visual feedback when complete
    if (code.length === this.lengthValue) {
      this.digitTargets.forEach(target => {
        target.classList.add('border-green-500', 'bg-green-50')
        target.classList.remove('border-gray-300')
      })
    } else {
      this.digitTargets.forEach(target => {
        target.classList.remove('border-green-500', 'bg-green-50')
        target.classList.add('border-gray-300')
      })
    }
  }
}
